export default "__VITE_ASSET__CsAw$7vV__"